import { playerEventsForMetricAtom, playerEventsForMetricCountAtom } from '@/atoms/queries/player/playerEventData';
import { EventsTableBase, EventsTableWithPagination } from '@/components/tables/EventsTable';
import { MetricKeyFallbackWrapper } from '@/components/metric/MetricKeyFallbackWrapper';

export const PlayerVisEventsTable = () => (
  <MetricKeyFallbackWrapper fallback={<EventsTableBase isLoading />}>
    <EventsTableWithPagination eventsAtom={playerEventsForMetricAtom} dataLengthAtom={playerEventsForMetricCountAtom} />
  </MetricKeyFallbackWrapper>
);
